import React from 'react';
import { motion } from 'framer-motion';
import { portfolioData } from '../data/mock';

const fadeUp = {
  hidden: { opacity: 0, y: 30 },
  visible: (i = 0) => ({
    opacity: 1,
    y: 0,
    transition: { duration: 0.8, delay: i * 0.15, ease: [0.25, 1, 0.5, 1] }
  })
};

const stats = [
  { label: 'Experience', value: portfolioData.about.experience },
  { label: 'Projects', value: portfolioData.about.projects },
  { label: 'Clients', value: portfolioData.about.clients },
];

const About = () => {
  return (
    <section id="about" data-testid="about-section" className="py-24 md:py-32 lg:py-40 bg-[#0A0A0A]">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12 md:gap-8 items-start">
          <motion.div
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, margin: "-100px" }}
            className="md:col-span-5 relative"
          >
            <motion.div variants={fadeUp} className="relative overflow-hidden">
              <img
                src="https://customer-assets.emergentagent.com/job_26e73d44-729e-4271-8d3d-3f29af78eb94/artifacts/ytieyph3_WhatsApp%20Image%202026-04-02%20at%2012.08.19%20PM.jpeg"
                alt="Nitin Sharma - Photographer"
                data-testid="about-image"
                className="w-full aspect-[3/4] object-cover"
              />
              <div className="absolute bottom-4 left-4 glass rounded-sm px-4 py-2">
                <p className="text-xs uppercase tracking-[0.2em] font-medium text-white/80">
                  {portfolioData.about.experience}
                </p>
              </div>
            </motion.div>
          </motion.div>

          <div className="md:col-span-6 md:col-start-7">
            <motion.div
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true, margin: "-100px" }}
            >
              <motion.p variants={fadeUp} custom={0} className="text-xs md:text-sm uppercase tracking-[0.3em] font-medium text-white/40 mb-4">
                About
              </motion.p>
              <motion.h2 variants={fadeUp} custom={1} className="font-serif text-4xl sm:text-5xl md:text-6xl font-light tracking-tight leading-tight text-white mb-8">
                The Vision Behind<br />the Lens
              </motion.h2>
              <motion.p variants={fadeUp} custom={2} className="text-base md:text-lg font-light tracking-wide leading-relaxed text-white/50 mb-12">
                {portfolioData.about.description}
              </motion.p>

              <motion.div variants={fadeUp} custom={3} className="grid grid-cols-3 gap-6 border-t border-white/10 pt-8">
                {stats.map((stat) => (
                  <div key={stat.label} data-testid={`about-stat-${stat.label.toLowerCase()}`}>
                    <p className="font-serif text-2xl md:text-3xl font-light text-white tracking-tight">{stat.value}</p>
                    <p className="text-xs uppercase tracking-[0.2em] text-white/40 mt-1">{stat.label}</p>
                  </div>
                ))}
              </motion.div>
            </motion.div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
